export enum PriorityProjectStatus {
  Current = 'current',
  Future = 'future',
}

export interface PriorityProject {
  title: string;
  icon?: string;
  dates?: string; // 23 сентября — 26 октября
  description: string;
  inform_message?: string;
  status: PriorityProjectStatus; //current, future, passed
  additional_dates?: { // test 1 and dates, test 2 and dates...
    name: string;
    dates: string;
  }[];
  ids_municipality: string; //"302,296,294,303,297,295,30319,30318"
}
